module.exports = __webpack_public_path__ + "static/media/invision.724c6cfa.png";